export * from "./BFFGatewayConfiguration";
//# sourceMappingURL=index.js.map